import { Inject, Injectable, EventEmitter, Output, PLATFORM_ID, Injector, Directive, makeStateKey, TransferState } from '@angular/core';
import { Observable, catchError, map, shareReplay, tap } from 'rxjs';
import { throwError, of, BehaviorSubject } from 'rxjs';
import 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { HttpClient } from '@angular/common/http';
// import { GuidService } from 'app/services/guid.service';
// import { windowService } from 'app/services/window.service';
// import { BackendService } from 'app/services/backend.service';
// import { SvcServices } from 'app/services/svc.service';
import { isPlatformBrowser } from '@angular/common';
import { GuidService } from './guid.service';
import { windowService } from './window.service';
import { BackendService } from './backend.service';
import { SvcServices } from './svc.service';

// State key to store data on server
const BRANDING_DATA_KEY = makeStateKey('brandingData');
const GLOBAL_DATA_KEY = makeStateKey('globalData');
const CONFIG_DATA_KEY = makeStateKey('configData');
const MODAL_DATA_KEY = makeStateKey('modalData');
const LANG_DATA_KEY = makeStateKey('LangData');
const MODULE_DATA_KEY = makeStateKey('moduleData');
const SIGN_ON_DATA_KEY = makeStateKey('signonData');
const CONFIG_FLAGS_KEY = makeStateKey('configFlags');

@Directive()
@Injectable()
export class ContentService {
  config: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;
  interstitialsCollect:any
  securityQuestionsResponse: any;  
  accountId: string = "";
  screenCaptureObj: any = {};

  constructor(
    private _appConfigService: AppConfigService,
    private _http: HttpClient,
    //private _storageService: StorageService,
    private guidService: GuidService,
    private transferState: TransferState,
    private windowService: windowService,
    private _svcService: SvcServices,    
    private router: Router,
    private route: ActivatedRoute,
    private _injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string
  ) { 
    this.setConfig();
  }
  
  clearCache(): void {
    console.log('Cache cleared for ContentService');
  }
  
  //Variables
  setConfig() {
    this.config = this._appConfigService.getConfig("api");
    // api = this.config;
    this.endpointMap =
      Object
        .keys(this.config?.endpoints)
        .reduce((map, endpoint, i) => {
          map[i] = [endpoint, this.config?.endpoints[endpoint]];
          return map;
        }, []);
    this.channel = this.config?.channel;
    this.endpoints = new Map(this.endpointMap);
  }
  pData: any;
  //currentLocaleId: any = this.getCurrentLocale();

   get backend(): BackendService {
          return this._injector.get<BackendService>(BackendService);
      }

  private currentBrandingContent = new BehaviorSubject(null);
  public branding_content = this.currentBrandingContent.asObservable();

  private currentModalContent = new BehaviorSubject<any>(null);
  public modal_content = this.currentModalContent.asObservable();

  private currentModuleData = new BehaviorSubject<any>(null);
  public module_content = this.currentModuleData.asObservable();

  private currentConfigData = new BehaviorSubject<any>(null);
  public config_content = this.currentConfigData.asObservable();

  private currentGlobalContent = new BehaviorSubject<any>(null);
  public global_content = this.currentGlobalContent.asObservable();

  private _isSignedOn = new BehaviorSubject<boolean>(false);
  isSignedOn$ = this._isSignedOn.asObservable();

  // from configflag/retrieve
  private currentConfigFlags = new BehaviorSubject<any>(null);  
  public config_flags_retrieve = this.currentConfigFlags.asObservable();
  private configFlagsRequest$: Observable<any> | null = null; 

  @Output() componentLoaded = new EventEmitter<boolean>();
  @Output() isSignOnLoaded = new EventEmitter<boolean>();

  businessIdDetails: any = {
    "PLCN_GOODYEAR": "GDYR",
    "GOODYEAR": "GDYR",
    "PLCN_MACYS": "MACY",
    "PLCN_BLOOMINGDALES": "BLMD",
    "PLCN_CTY": "CTY",
    "PLOC_SHELL": "SHLL",
    "PLCN_BESTBUY": "BB",
    "PLCN_HOMEDEPOT": "THD",
    "CACN_HOMEDEPOT": "THD_CA",
    "PLOC_SUNOCO": "SUN",
    "PLOC_EXXONMOBIL": "EXMB",
    "PLCN_BROOKSBROTHERS": "BROOKS",
    "PLCN_LINCOLNSERVICES": "LINC",
    "PLCN_SERVICE": "FRD",
    "PLCN_POLARIS": "PLRS",
    "PLCN_AMERICAN": "AA",
    "PLCN_BRANDSOURCE": "BRND",
    "PLCN_JEWELRY": "JWL",
    "PLCN_OFFICEDEPOT": "OFDPT",
    "PLCN_STAPLES": "STPL",
    "PLCN_TRACTORSUPPLY": "TS",
    "PLCN_DRIVECARD": "DRV",
    "PLOC_WAWA": "WAWA",
    "PLCN_BRP": "BMBDR",
    "PLCN_SERVICECENTRAL": "TBC",
    "PLCN_TORO": "TORO",
    "PLCN_COSTCO": "COSTCO",
    "PLCN_LLBEAN": "LLBEAN",
    "PLCN_MEIJER": "MJ",
    "PLCN_WFCC": {"AM":"AM","WF":"WF", "JM":"JM","PR":"PR","BL":"BL","default":"WF"},
    "PLCN_HNPE": "HONDA_PE",
    "PLCN_HNPS": "HONDA_PS",
    "PLCN_KAWA": "KAWA",
    "PLCN_CAT": "CAT",
    "PLCN_HOME": "HMF",
    "PLCN_ELECAPPL": "CENA",
    "PLCN_SYW": "SYW",
    "PLCN_CPAY":"CPAY",
    "PLCN_OSTK": 'OS',
    "PLCN_DILLARDS": 'DL'
  }

  pageDefMap: any = {
    "signon": "jCARDS_svc_cw_sign_on",
    "singlesignon": "jCARDS_svc_cw_single_sign_on",
    "browser": "jCARDS_svc_unsupported_browser_upgrade",
    "ssologin": "jCARDS_svc_cw_sign_on",
    "tyRewardsSignon": "jCARDS_svc_cw_sign_on",
    "ssoauthenticate": "jCARDS_svc_cw_single_sign_on",
    "ssoauthorize": "jCARDS_svc_cw_single_sign_on"
  }


  // CONTENT CALLS

  /** 
   * Branding Data => HTTP request for partner branding data.
   * Check if available in current TransferState API, else generate request
   */
  getBrandingContent() {

    let langId = this.getLang();

    if (this.transferState.hasKey(BRANDING_DATA_KEY) && this.getCurrentLocale() == langId) {
      //if transfer state has accounts data, fetch it from transfer state storage
      const res = of(this.transferState.get(BRANDING_DATA_KEY, null as any));
      //set observable
      this.currentBrandingContent.next(this.transferState.get(BRANDING_DATA_KEY, null as any));
      return res;
    }
    else {
      let uuid = this.guidService.getGuid();
      const headers = {
        'Accept-Language': this.changeLangIdForFrenchPartnerCMS(langId),
        'uuid': uuid
      };
      const pathParams = {
        "BUSID": this.getBusinessID()
      };
      if (!pathParams["BUSID"]) {
        console.warn('ContentService: Not making branding content call because businessID is undefined. Params:', pathParams);
        return of(null);
      }
      let url = this.endpoints.get('contentServiceBrandingUrl');
      if (isPlatformBrowser(this.platformId)) {
        url = 'v1/' + url;
      }
      return this.backend.get(url, null, headers, pathParams).pipe(
          map((res: any) => {
            let result = res.body;
            if (result && result.content && result.content.CARDS && Object.keys(result.content.CARDS).length > 0) {
              this.currentBrandingContent.next(result);
              this.transferState.set(BRANDING_DATA_KEY, result);
            } else {
              console.error(`ERROR_LOGGER|${headers}|langid - ${langId} | URL - ${url} |pathParams - ${pathParams}`)
              //console.error(`ERROR_LOGGER|${uuid}|response body for branding call is empty - ${JSON.stringify(result)}`)
            }
            return result;
          })
          // shareReplay(1)
      )

    }
  }

  /** 
   * Modal Data => HTTP request for partner Modal data.
   * Check if available in current TransferState API, else generate request
   */
  getModalContent(pageDef?: string) {
    
    let langId = this.getLang();

    if (this.transferState.hasKey(MODAL_DATA_KEY) && this.getCurrentLocale() == langId) {
      //if transfer state has accounts data, fetch it from transfer state storage
      const res = of(this.transferState.get(MODAL_DATA_KEY, null as any));
      //set observable
      this.currentModalContent.next(this.transferState.get(MODAL_DATA_KEY, null as any));
      return res;
    }
    else {
      let page_def = this.pageDefMap[this.pData.pageName];
      if (pageDef) {
        page_def = pageDef;
      }
      let uuid = this.guidService.getGuid();
      const headers = {
        'Accept-Language': this.changeLangIdForFrenchPartnerCMS(langId),
        'uuid': uuid
      };
      const pathParams = {
        "BUSID": this.getBusinessID(),
        "PAGEDEF": page_def
      };
      if (!pathParams["BUSID"]) {
        console.warn('ContentService: Not making modal content call because businessID is undefined. Params:', pathParams);
        return of(null);
      }
      let url = this.endpoints.get('contentServicePageDefUrl');
      if (isPlatformBrowser(this.platformId)) {
        url = 'v1/' + url;
      }
      return this.backend.get(url, null, headers, pathParams).pipe(
          map((res: any) => {
            let result = res.body;
            if (result && result.content && result.content.CARDS && Object.keys(result.content.CARDS).length > 0) {
              this.currentModalContent.next(result);
              this.transferState.set(MODAL_DATA_KEY, result);
            } else {
              console.error(`ERROR_LOGGER|${headers}|langid - ${langId} | URL - ${url} |pathParams - ${pathParams}`)
              //console.error(`ERROR_LOGGER|${uuid}|response body for Modal content call is empty - ${JSON.stringify(result)}`)
            }
            return result;
          })
          // shareReplay(1)
      )

    }
  }

  /** 
   * Module Data => HTTP request for Module data based on PageDef.
   * Check if available in current TransferState API, else generate request
   */
  getModuleContent(pageDef?: string) {

    
    let langId = this.getLang();

    if (this.transferState.hasKey(MODULE_DATA_KEY) && this.getCurrentLocale() == langId) {
      //if transfer state has accounts data, fetch it from transfer state storage
      const res = of(this.transferState.get(MODULE_DATA_KEY, null as any));
      //set observable
      this.currentModuleData.next(this.transferState.get(MODULE_DATA_KEY, null as any));

      return res;
    }
    else {
      let page_def = this.pageDefMap[this.pData.pageName];
      if (pageDef) {
        page_def = pageDef;
      }
      let uuid = this.guidService.getGuid();
      const headers = {
        'Accept-Language': this.changeLangIdForFrenchPartnerCMS(langId),
        'uuid': uuid
      };
      const pathParams = {
        "BUSID": this.getBusinessID(),
        "PAGEDEF": page_def
      };
      if (!pathParams["BUSID"]) {
        console.warn('ContentService: Not making module content call because businessID is undefined. Params:', pathParams);
        return of(null);
      }
      let url = this.endpoints.get('contentServicePageDefUrl');
      if (isPlatformBrowser(this.platformId)) {
        url = 'v1/' + url;
      }
      const acceptLan = this.changeLangIdForFrenchPartnerCMS(langId);
      const businessIDNewCustom =this.getBusinessID();

      return this.backend.get(url, null, headers, pathParams).pipe(
          map((res: any) => {
            let result = res.body;
            if (result && result.content && result.content.CARDS && Object.keys(result.content.CARDS).length > 0) {
              this.currentModuleData.next(result);
              this.transferState.set(MODULE_DATA_KEY, result);
            } else {
              console.error(`ERROR_LOGGER|${acceptLan}|langid - ${langId} | URL - ${url} | businessIDNewCustom - ${businessIDNewCustom} | page_def - ${page_def}`)
              //console.error(`ERROR_LOGGER|${uuid}|response body for page def content call is empty - ${JSON.stringify(result)}`)
            }
            return result;
          }),
          // shareReplay(1)
      )
    }
  }

  getConfigContent() {

    let langId = this.getLang();

    if (this.transferState.hasKey(CONFIG_DATA_KEY) && this.getCurrentLocale() == langId) {
      //if transfer state has accounts data, fetch it from transfer state storage
      const res = of(this.transferState.get(CONFIG_DATA_KEY, null as any));
      //set observable
      this.currentConfigData.next(this.transferState.get(CONFIG_DATA_KEY, null as any));

      return res;
    }
    else {

      let uuid = this.guidService.getGuid();
      const headers = {
        'Accept-Language': this.changeLangIdForFrenchPartnerCMS(langId),
        'uuid': uuid
      };
      const pathParams = {
        "BUSID": this.getBusinessID()
      };
      if (!pathParams["BUSID"]) {
        console.warn('ContentService: Not making config content call because businessID is undefined. Params:', pathParams);
        return of(null);
      }
      let url = this.endpoints.get('contentServiceConfigUrl');
      if (isPlatformBrowser(this.platformId)) {
        url = 'v1/' + url;
      }
      const acceptLan = this.changeLangIdForFrenchPartnerCMS(langId);
      const businessIDNewCustom =this.getBusinessID();

      return this.backend.get(url, null, headers, pathParams).pipe(
        map((res: any) => {
          let result = res.body;
          if (result && result.content && result.content.CARDS && Object.keys(result.content.CARDS).length > 0) {
            this.currentConfigData.next(result);
            this.transferState.set(CONFIG_DATA_KEY, result);
          } else {
            console.error(`ERROR_LOGGER|${acceptLan}|langid - ${langId} | URL - ${url} | businessIDNewCustom - ${businessIDNewCustom}`)
          }
          return result;
        }),
        // shareReplay(1)
      )
    }
  }

  getConfigFlags() {  
    const langId = this.getLang();  
    console.log('isTransferState '+ this.transferState.hasKey(CONFIG_FLAGS_KEY) )
    // 1. TransferState hit (hydrated server-side) -> return without any network call  
    if (this.transferState.hasKey(CONFIG_FLAGS_KEY) && this.getCurrentLocale() == langId) {  
      const cached = this.transferState.get(CONFIG_FLAGS_KEY, null as any);  
      this.currentConfigFlags.next(cached); 
      return of(cached);  
    }  

    // 2. Browser cache-miss -> DO NOT call the View API in the browser.  
    //    Returning null lets getAppClientSettings() use the BAU cfg_cw_app_client_settings  
    //    fallback, guaranteeing no configFlags/retrieve request appears in the network tab.  
    if (isPlatformBrowser(this.platformId)) {  
      return of(this.currentConfigFlags.value);  
    }  
    
    //  Server: de-dup concurrent callers with a single in-flight request  
    if (this.configFlagsRequest$) {  
      return this.configFlagsRequest$;  
    }  
    // 3. Server-only: fetch the View API and prime TransferState + BehaviorSubject  
    const uuid = this.guidService.getGuid();  
    const headers = {  
      'Accept-Language': this.changeLangIdForFrenchPartnerCMS(langId),  
      'uuid': uuid,
      'siteId': this._svcService.getSiteId()  
    };  
    const url = this.endpoints.get('appClientSettingsNew');  
    console.log("app client url",url);
    
    
    this.configFlagsRequest$ =  this.backend.post(url, null, headers, {}).pipe(  
      tap(response =>{ console.log('config backend response '+ response)}),
    map((res: any) => {  
      const result = res?.body; 
      // Validation gate: only accept a well-formed 200/SUCCESS response  
      const isValid = result  
        && result.responseCode === '200'  
        && result.responseStatus === 'SUCCESS'  
        && result.cfg_cw_app_client_settings
        && Object.keys(result.cfg_cw_app_client_settings).length > 0;   

      const settings = isValid ? result.cfg_cw_app_client_settings : null;  
        if (isValid) {  
          this.currentConfigFlags.next(settings);      
          this.transferState.set(CONFIG_FLAGS_KEY, settings);  
        }  
        return settings;
      }),
      catchError((error) => {  
        // View API unavailable -> let callers fall back to BAU cfg_cw_app_client_settings  
        console.error('Error fetching config flags (View API):', error);  
        return of(null);  
      }) , 
      shareReplay(1)  
    ); 
    return this.configFlagsRequest$;   
}



  /* Synchronous read of the flat app client settings.
     Reads the TransferState-hydrated View API flags first and falls back to the
     BAU cfg_cw_app_client_settings block of the already fetched config content. */
  getConfigFlagsSync(): any {
    const flags = this.currentConfigFlags.value;
    if (flags && Object.keys(flags).length > 0) {
      return flags;
    }
    return this.currentConfigData.value?.content?.CARDS?.config$$cfg_cw_app_client_settings ?? null;
  }

  // SUPPORTING METHODS

  pageContent: any
  
  setModuleContent(data) {
    this.pageContent = data;
  }

  getContent() {
    return this.pageContent;
  }

  getBusinessID() {
    if (!this.pData || !this.pData.siteId) {
      console.warn('ContentService.getBusinessID: pData or siteId is undefined:', this.pData);
      return undefined;
    }
    let brandId = this.pData.brandId ? this.pData.brandId.toUpperCase() : undefined;
    let businessId  =this.businessIdDetails[this.pData.siteId.toUpperCase()];
    //if brandId exist for any partner like Wayfair, use the businessId of brand
    if (businessId && typeof businessId !== 'string') {
      businessId = businessId[brandId] ? businessId[brandId] : businessId['default'];
    }
    console.log("businessId == ", businessId);
    return businessId;
  }

  setParams(data: any) {
    console.log("Data SetParams", data);
    this.pData = data;
  }

  getParams() {
        return this.pData;
  }

  getLang() {
    if(this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
      return this.pData.langId ? this.pData.langId : 'en_CA';
    } else {
      return this.pData.langId ? this.pData.langId : 'en_US';
    };
  }

  // getCurrentLocale() {
  //   if(this.pData && this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
  //     return "en_CA";
  //   } else {
  //     return "en_US";
  //   };
  // }

  getCurrentLocale() {
    if(isPlatformBrowser(this.platformId)) {
      const localSiteId = localStorage.getItem("siteLocal_ID");
      if(this.pData && this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
        return localSiteId ? localSiteId : "en_CA";      
      } else {
        return localSiteId ? localSiteId : "en_US";
      }
    } else {
      return this.getLang();
    }
  }

  /**
   * Returns the TEXT value for given content Id
   * @param contentId - content id
   */
  getCopyTxt(contentId) {
    let copyTxt = '';
    if (this.pageContent && this.pageContent["copy$$" + contentId]) {
      copyTxt = this.pageContent["copy$$" + contentId]["TEXT"];
    }
    return copyTxt;
  }

  headerConfig() {
    let headerParam = {
      'Content-Type': 'application/json',
      "uuid": this.guidService.getGuid(),
      "client_id": this._svcService.getClientIdfromHeader(),
      "businessCode": 'CRS',
      "Accept-Language": 'en-US',
      "countryCode": 'US'
    };
    return headerParam;
  }

  handleError(error: any) {
    if (error.status >= 200) {
      let message = "Error Code: " + error.status + "\n Error Status: " + error.statusText + "\n" + error;
      return throwError(new Error(message));
    }
  }

  getWindowIdFromSessionStorage(): string {
    let window_id: string;
    try {
      window_id = sessionStorage.getItem('window_id');
      if (!window_id) {
        window_id = String(Date.now());
      }
    } catch (err) {
      console.log("Session storage not supported");
    }
    return window_id;
  }

  createKnownUserKey(): void {
    //Called when user successfully logins
    const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
    if (!localStorage.getItem(partnerLoggedInKey)) {
      localStorage.setItem(partnerLoggedInKey, "true");
    }
  }

  isKnownUser(): boolean {
    //Check if user successfully logged in before
    const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
    if (localStorage.getItem(partnerLoggedInKey)) {
      return true;
    } else {
      return false;
    }
  }

  isUnknownUser(): boolean {
    //Check if user successfully logged in before
    const partnerLoggedInKey = 'signed_on_' + this.getBusinessID();
    if (localStorage.getItem(partnerLoggedInKey)) {
      return false;
    } else {
      return true;
    }
  }

  createNewContentCallUrl(subpath) {
    //takes a subpath and generates an absolute url
    //ex url generated: https://dit06.mobile.citibank.com/gcgapi/dev2/v1/content/subBusinessID/BUSID/applicationID/CARDS/contentType/cmcomponent/viewID/cmpnt_svc_cw_branding_primary?isStaticRequired=true

    //for local dev, just return the subpath
    // if(this.windowService.nativeWindow.location.host === "localhost:4200"){
    //   return subpath
    // } else {
    var config = this._appConfigService.getConfig("api");
    var api = config;
    var url = window.location.origin + '/' + api.path + 'v1/' + subpath;
    return url;
  // }


  }

    changeLangIdForFrenchPartnerCMS(currentLocaleId){
      if(this.pData && this.pData.siteId && this.pData.siteId.toLowerCase() === 'cacn_homedepot'){
        if(currentLocaleId === 'en_CA' || currentLocaleId === 'en_US'){
            return currentLocaleId = 'ca_US';
        } else if (currentLocaleId === 'fr_CA' || currentLocaleId === 'fr_US'){
            return currentLocaleId = 'fr_US';
        } else {
            return currentLocaleId;
        }
      } else {
        if(currentLocaleId === 'en_CA'){
          return currentLocaleId = 'ca_US';
        } else if (currentLocaleId === 'fr_CA'){
            return currentLocaleId = 'fr_US';
        } else {
            return currentLocaleId;
        }
      }
  }

  getSelectiveContent(contentId, type, attribute) {
    let copyTxt = '';
    if (this.pageContent && this.pageContent[type + "$$" + contentId]) {
      copyTxt = this.pageContent[type + "$$" + contentId][attribute];
    }
    return copyTxt;
  }

  scrollToTop() {
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  }

  setInterstitialsCollect(interstitialsCollect: string) {
    this.interstitialsCollect = interstitialsCollect;
  }

  getInterstitialsCollect(): string {
    return this.interstitialsCollect;
  }

  setSignonResponse(sqResponse: any): void {
    this.securityQuestionsResponse = sqResponse;
  }

  getSignonResponse(): any {
    return this.securityQuestionsResponse;
  }

  get isSignedOn(): boolean {
    return this._isSignedOn.getValue();
  }

  set isSignedOn(value: boolean) {
    this._isSignedOn.next(value);
  }

}


